var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEyeInvisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2120_8497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0027 4.41856C13.4442 4.4138 14.8287 4.99343 15.852 6.03014C16.8753 7.06685 17.4538 8.47588 17.4605 9.94778C17.4606 10.6414 17.3279 11.3284 17.0697 11.97L20.2568 15.1962C21.9174 13.7956 23.2051 11.9899 24.0008 9.94622C22.7571 6.77654 20.3587 4.22241 17.3094 2.82048C14.2601 1.41855 10.7973 1.27795 7.64859 2.42822L10.0054 4.81833C10.6403 4.55692 11.3181 4.42125 12.0027 4.41856ZM1.09233 1.40544L3.5832 3.92622L4.08671 4.43489C2.26248 5.86257 0.850387 7.76746 0 9.94778C1.27569 13.1906 3.75731 15.7856 6.90199 17.1651C10.0467 18.5445 13.5984 18.5962 16.7803 17.3087L17.2373 17.7753L20.4366 21.0016L21.8237 19.5946L2.47564 0L1.09233 1.40544ZM7.12223 7.51411L8.8148 9.22522C8.75918 9.45982 8.7303 9.70019 8.72873 9.94156C8.73012 10.3789 8.81601 10.8117 8.98148 11.2151C9.14695 11.6186 9.38874 11.9847 9.69301 12.2925C9.99727 12.6004 10.358 12.8439 10.7546 13.0092C11.1512 13.1745 11.5758 13.2582 12.0042 13.2557C12.2423 13.2546 12.4795 13.2254 12.7111 13.1686L14.4037 14.8797C13.577 15.3018 12.6585 15.5015 11.7351 15.4597C10.8118 15.418 9.91414 15.1363 9.12726 14.6412C8.34038 14.1461 7.69032 13.4541 7.23867 12.6307C6.78701 11.8073 6.54872 10.8798 6.54635 9.93611C6.55295 9.09425 6.75004 8.26534 7.12223 7.51411ZM11.8244 6.65856L15.2629 10.1422L15.2842 9.96722C15.2828 9.52985 15.1969 9.09706 15.0315 8.69364C14.866 8.29022 14.6242 7.92409 14.3199 7.61624C14.0157 7.30838 13.6549 7.06484 13.2583 6.89957C12.8617 6.7343 12.4371 6.65055 12.0088 6.65311L11.8244 6.65856Z",
    fill: "black",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2120_8497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeInvisible);
export default __webpack_public_path__ + "static/media/IconEyeInvisible.35cd015530015d3e32985177ed1bc095.svg";
export { ForwardRef as ReactComponent };